import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerAssistant: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const { customSkillsRequestHandler } = await import("./mocks/custom-skills/customSkillsRequestHandler.ts");

        runtime.registerRequestHandlers([customSkillsRequestHandler]);
    }
};
